export default __webpack_public_path__ + "static/media/intro5.f5adea7a.mp3";